<template>
<header :style="topBannerNavBg">
  <div class="container">
    <div id="nav">
      <router-link class="logo" to="/" tag="div">
        <img src="@/assets/images/logo.png" alt="" />
      </router-link>

      <div class="menu nav-menu">
        <ul>
          <li @mouseover="addClass($event)" @mouseleave="rmClass($event)" v-for="(item, i) in navItems" :key="i" @click="toLink(item.link, $event)">
            {{ item.text }}
            <el-badge is-dot class="item" :hidden="item.isred"></el-badge>
          </li>
        </ul>
      </div>
      <div class="menu logined" v-if="hasToken">
        <el-dropdown trigger="click">
          <div class="el-dropdown-link">
            <ul>
              <li class="loginhead">
                <img class="headpicture" v-if="headicon" :src="imgUrl + headicon" alt="" />
                <img class="headpicture" v-else src="../assets/images/mycenterheadpicture.png" alt="" /><span class="logintext">{{ username }}</span>
              </li>
            </ul>
          </div>
          <el-dropdown-menu slot="dropdown">
            <router-link :to="{path:'/mycenter',query:{roleId:userid}}">
              <el-dropdown-item icon="el-icon-s-home">个人中心</el-dropdown-item>
            </router-link>
            <el-dropdown-item icon="el-icon-edit" @click.native="dialogFormVisible = true">修改密码</el-dropdown-item>
            <router-link to="/">
              <el-dropdown-item icon="el-icon-right" @click.native="clearlogin()">退出登录</el-dropdown-item>
            </router-link>

          </el-dropdown-menu>
        </el-dropdown>
        <el-dialog title="修改密码" :visible.sync="dialogFormVisible" width="30%" center append-to-body>
          <el-form class="flexcontent">
            <el-input v-model="newpassword" placeholder="新密码" show-password></el-input>
            <el-input v-model="surepassword" placeholder="确认密码" show-password></el-input>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="changepassword">确 定</el-button>
          </div>
        </el-dialog>
      </div>
      <div class="menu login-menu" v-else>
        <ul>
          <li @mouseover="addClass($event)" @mouseleave="rmClass($event)" v-for="(item, i) in loginItems" :key="i" @click="toLink(item.link, $event)">
            <img :src="item.icon" alt="" /><span>{{ item.text }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</header>
</template>

<script>
const navItems = [{
    text: "首页",
    link: "/",
    isred: true
  },
  {
    text: "圈子",
    link: "/about",
    isred: true
  },
  {
    text: "圈友",
    link: "/friend",
    isred: true
  },
  {
    text: "动态",
    link: "/moments",
    isred: true
  },
  {
    text: "企业",
    link: "/job",
    isred: true
  },
  {
    text: "询价",
    link: "/price",
    isred: true
  }
];
const imgUrl = "https://ringstar.xhqj71.com/jeecg-boot/sys/common/static/"; //公共路径 
const loginItems = [{
    text: "登录",
    link: "/login",
    icon: require("../assets/images/login_ico.png")
  },
  {
    text: "注册",
    link: "/reg",
    icon: require("../assets/images/reg_ico.png")
  }
];
import {
  queryById
} from "../api/api"
import router from "../router";
import {
  getpropertylist,
  Changepassword
} from "../api/api";
export default {
  name: "headers",
  data() {
    return {
      topBannerNavBg: {
        backgroundColor: ""
      },
      navItems: navItems,
      loginItems: loginItems,
      navIn: "nav-out",
      hasToken: true,
      username: "",
      headicon: "",
      imgUrl,
      userid: "",
      dialogFormVisible: false,
      newpassword: "",
      surepassword: "",
      msg: "",
    };
  },
  mounted() {
    if (this.hasToken)   {

const value = this.$store.state.globalVariable;
    if (value == 0) {
      this.navItems[2].isred = true;
    }
  
//     const self = this;
//     //定时器 只执行一次的那种 只是为了限制重连频率 = =
//     var heartCheck = {
//         timeout: 2000, //重连时间
//         timeoutObj: null,
//         start: function(){
//             this.timeoutObj = setTimeout(function(){
//                 //连接成功建立的回调方法
//               var websocket = null;
   
//     var userId = JSON.parse(
//       sessionStorage.getItem("userinfo_Data")
//     ).id
//     if ('WebSocket' in window && !websocket) {
//       // websocket = new WebSocket("wss://www.xhqj71.com/jeecg-boot/websocketRingStar/" + userId);
// websocket = new WebSocket("wss://www.xhqj71.com/jeecg-boot/websocketRingStar/" + userId);
//     } else {
//       alert('当前浏览器 Not support websocket')
//     }
//     let isConnected = false;
//     //连接发生错误的回调方法
//     websocket.onerror = function () {
//       console.log("WebSocket连接发生错误");
//     };

//     //连接成功建立的回调方法
//     if (!isConnected) {
//       websocket.onopen = function connectWebSocket() {
//         console.log("WebSocket连接成功");
//         isConnected = true;
//       }

//     }
//     websocket.onclose = function (e) {
//       console.log('websocket 断开: ' + e.code + ' ' + e.reason + ' ' + e.wasClean)
//        heartCheck.start();
//     }
//     //接收到消息的回调方法
    
//     websocket.onmessage = (event) => {
//       console.log(event.data);
//       console.log(self.navItems[2])
//      self.navItems[2].isred = false;
//        self.$store.commit('updateGlobalVariable', 1);
//       self.someValue = event.data
//       //  this.playAudio()
//       let buttonAudio = document.getElementById('my_audio');
//       var audio = require('../assets/audios/y1479.mp3')
//       buttonAudio.setAttribute('src', audio)
//       buttonAudio.play()
//     }
//     window.onbeforeunload = function () {
//       websocket.close();
//     }//这里重新创建 websocket 对象并赋值
//             }, this.timeout)
//         }
//     }

   

   
//     //连接成功建立的回调方法
//     var websocket = null;
//     var userId = JSON.parse(
//       sessionStorage.getItem("userinfo_Data")
//     ).id
   
//     if ('WebSocket' in window && !websocket) {
//       websocket = new WebSocket("wss://www.xhqj71.com/jeecg-boot/websocketRingStar/" + userId);

//     } else {
//       alert('当前浏览器 Not support websocket')
//     }
//     let isConnected = false;
//     //连接发生错误的回调方法
//     websocket.onerror = function () {
//       console.log("WebSocket连接发生错误");
//     };

//     //连接成功建立的回调方法
//     if (!isConnected) {
//       websocket.onopen = function connectWebSocket() {
//         console.log("WebSocket连接成功");
//         isConnected = true;
//       }

//     }
//     websocket.onclose = function (e) {
//       console.log('websocket 断开: ' + e.code + ' ' + e.reason + ' ' + e.wasClean)
//        heartCheck.start();
//     }
//     //接收到消息的回调方法
    
//     websocket.onmessage = (event) => {
//       console.log(event.data);
//       this.navItems[2].isred = false;
//       this.$store.commit('updateGlobalVariable', 1);
//       this.someValue = event.data
//       //  this.playAudio()
//       let buttonAudio = document.getElementById('my_audio');
//       var audio = require('../assets/audios/y1479.mp3')
//       buttonAudio.setAttribute('src', audio)
//       buttonAudio.play()
//     }
//     window.onbeforeunload = function () {
//       websocket.close();
//     }
    
    window.addEventListener("scroll", this.handleScroll);

    }
    
  },
  created() {
    this.islogin();
    if (this.hasToken) {
     
      this.roleId = this.$route.query.roleId
      this.userid = JSON.parse(
        sessionStorage.getItem("userinfo_Data")
      ).id
    }
    queryById({
      id: this.userid,
    }).then(res => {
      if (res.data.code == 200) {
        if (res.data.result.loginState) {
          this.msg = res.data.result.stop1Txt;
          this.open();
          sessionStorage.clear();
        }
      }
    });
    if (this.hasToken) {
      this.getlistitems()
    }
  },
  methods: {
    getlistitems() {
      let time = []
      getpropertylist({
        pageNo: 1,
        userId: this.userid,
      }).then(res => {
        this.aboutItems = res.data.result.records

        res.data.result.records.forEach((item, i) => {
          if (!sessionStorage.getItem("indexTime")) {
            time.push({
              id: item.id,
              time: this.currentTime(),
            })

          } else {
            time.push({
              id: item.id,
              time: JSON.parse(sessionStorage.getItem("indexTime"))[i].hasOwnProperty("time") ? JSON.parse(sessionStorage.getItem("indexTime"))[i].time : this.currentTime(),
            })
          }
        })
        sessionStorage.setItem("indexTime", JSON.stringify(time))

      });

      return true
    },
    currentTime() {
      var date = new Date();
      var year = date.getFullYear(); //月份从0~11，所以加一
      let month = date.getMonth();
      var dateArr = [
        date.getMonth() + 1,
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds(),
      ];
      //如果格式是MM则需要此步骤，如果是M格式则此循环注释掉
      for (var i = 0; i < dateArr.length; i++) {
        if (dateArr[i] >= 1 && dateArr[i] <= 9) {
          dateArr[i] = "0" + dateArr[i];
        }
      }
      var strDate =
        year +
        "-" +
        dateArr[0] +
        "-" +
        dateArr[1] +
        " " +
        dateArr[2] +
        ":" +
        dateArr[3] +
        ":" +
        dateArr[4];
      //此处可以拿外部的变量接收  strDate:2022-05-01 13:25:30
      //this.date = strDate;
      return strDate;
    },
    toLink(link, $event) {
      [].forEach.call(document.getElementsByTagName("li"), function (item) {
        item.className = "";
      });
      $event.target.className = "selected";
      router.push(link || "/");
    },
    addClass($event) {
      if (
        !$event.target.className.match(
          new RegExp("(\\s|^)" + "selected" + "(\\s|$)")
        )
      ) {
        $event.target.className = " ";
      }
      if (
        !$event.target.className.match(
          new RegExp("(\\s|^)" + "nav-in" + "(\\s|$)")
        )
      ) {
        $event.target.className += " " + "nav-in";
      }
    },
    rmClass($event) {
      if (
        !$event.target.className.match(
          new RegExp("(\\s|^)" + "selected" + "(\\s|$)")
        )
      ) {
        $event.target.className = " ";
      }
      if (
        !$event.target.className.match(
          new RegExp("(\\s|^)" + "nav-out" + "(\\s|$)")
        )
      ) {
        $event.target.className += " " + "nav-out";
      }
    },
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // 设置背景颜色的透明度
      if (scrollTop) {
        this.topBannerNavBg.backgroundColor = "#1e232f"; // scrollTop + 多少根据自己的需求设置
      } else if (scrollTop === 0) {
        this.topBannerNavBg.backgroundColor = "transparent"; // 设置回到顶部时，背景颜色为透明
      }
    },
    // 滚动之前重置
    beforeDestroy() {
      window.removeEventListener("scroll", this.handleScroll);
    },
    islogin() {

      if (sessionStorage.getItem("token")) {
        this.hasToken = true;
        this.username = JSON.parse(
          sessionStorage.getItem("userinfo_Data")
        ).mininame;
        this.headicon = JSON.parse(
          sessionStorage.getItem("userinfo_Data")
        ).personPic;
      } else {
        this.hasToken = false;
      }
    },
    clearlogin() {
      this.hasToken = false
      sessionStorage.clear();

    },
    open() {
      this.$msgbox({
        title: "提示",
        message: `${this.msg}`,
        type: "warning",
        center: true,
        confirmButtonText: "确定"
      }).then(() => {});
    },
    changepassword() {

      var passwordreg = /^[a-zA-Z\d]{6,16}$/;

      if (!passwordreg.test(this.newpassword)) {
        this.msg = "密码应为6-16位字符";
        this.open();;
      }
      if (this.newpassword !== this.surepassword) {
        this.msg = "两次密码不一致";
        this.open();

      }

      if (!(!passwordreg.test(this.newpassword) || this.newpassword !== this.surepassword)) {
        let data = {
          id: this.userid,
          password: this.surepassword,
        };
        // console.log(data);
        Changepassword(data).then(res => {
          if (res.data.code == 200) {
            this.msg = res.data.message;
            this.open();
            this.dialogFormVisible = false;
            this.newpassword = ""
            this.surepassword = ""
          }
        });

      }

    }
  }
};
</script>

<style lang="scss" scoped>
.headpicture {
  width: 40px;
  height: 40px;
  border-radius: 50%;
      object-fit: cover;
}

.el-input {
  width: 300px;
  margin-bottom: 20px;
}

>>>.el-dialog--center .el-dialog__body {
  text-align: center;
}

>>>.el-badge__content {

  margin-bottom: 4px;

}
</style>



// WEBPACK FOOTER //
// src/components/headers.vue